'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  requestWithRateLimitHandling
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/packages/detail.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var QUERY = gql`
  query getPackages($lang: String, $limit: Int, $skip: Int, $where: PackageFilter, $order: [PackageOrder]) {
    packageCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
      total
      items {
        __typename
        id
        title
        subtitle
        description {
          json
        }
        eventLogo {${IMAGE_QUERY}}
        slug
        category{
          id
          title
          slug
        }
        ticketingUrlSlug
        image11 {${IMAGE_QUERY}}
        image31 {${IMAGE_QUERY}}
        originalPrice
        startingPrice
        currencyCode
        schedule {${SCHEDULE_QUERY}}
        zoneEntryIncluded
        buttonLabel
        cardButtonLabel
        eventType
        buttonLink
        isComingSoon
        contentListCollection(limit: 10) {
          items {
            id
            title
            qaListCollection(limit: 20) {
              items {
                title
                iconType
              }
            }
          }
        }
        carousalCollection(limit: 40) {
          items {${IMAGE_QUERY}}
        }
        cmsTagsCollection(limit: 10){
          items {${TAG_QUERY}}
        }
        sponsorsCollection(limit: 10) {
          items {
            id
            title
            sponsorsCollection(limit: 10) {
              items {
                id
                title
                logo {${IMAGE_QUERY}}
                link
              }
            }
          }
        } 
      }
    }
  }
`;
var getPackageDetail = (props) => __async(void 0, null, function* () {
  var _a, _b, _c;
  try {
    const res = yield requestWithRateLimitHandling(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang)
    }));
    return {
      data: (_b = (_a = res.packageCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0],
      rateLimited: (_c = res.rateLimited) != null ? _c : false
    };
  } catch (error) {
    throw new Exception({ error, name: "getPackagesException" });
  }
});
var useGetPackageDetail = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getPackageDetail", props],
    queryFn: () => getPackageDetail(props)
  }, options));
};

export {
  getPackageDetail,
  useGetPackageDetail
};
//# sourceMappingURL=chunk-FIMATCW4.mjs.map